import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="About Hero Background" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <h1>About TecMates</h1>
          <p>Your trusted partner for end-to-end IT solutions and digital transformation</p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="about-overview">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <h2>Who We Are</h2>
              <p>TecMates Infocom Private Limited is a new-age IT solutions company, driven by innovation and committed to delivering end-to-end technology solutions. As a trusted system integrator, we empower organizations to accelerate their digital transformation journeys through scalable, secure, and high-performance IT infrastructure.</p>
              
              <p>With a focus on reliability and customer-centricity, TecMates delivers tailored solutions designed to meet the unique needs of businesses across industries. Our goal is to enable smarter operations, seamless connectivity, and long-term technology resilience through future-ready, performance-driven systems.</p>
              
              <div className="about-stats">
                <div className="stat-item">
                  <h3>100+</h3>
                  <p>Happy Clients</p>
                </div>
                <div className="stat-item">
                  <h3>500+</h3>
                  <p>Projects Completed</p>
                </div>
                <div className="stat-item">
                  <h3>10+</h3>
                  <p>Years Experience</p>
                </div>
                <div className="stat-item">
                  <h3>24/7</h3>
                  <p>Hours Support</p>
                </div>
              </div>
            </div>
            <div className="about-image">
              <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="TecMates Team" />
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission">
        <div className="container">
          <div className="vision-mission-grid">
            <div className="vision-card">
              <div className="card-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h2>Our Vision</h2>
              <p>To be one of the most sought-after IT solution providers, recognized for our reliability, agility, and commitment to excellence. We strive to be the preferred partner for organizations seeking innovative technology solutions that drive business growth and digital transformation.</p>
            </div>
            
            <div className="mission-card">
              <div className="card-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h2>Our Mission</h2>
              <p>To help organizations streamline their business processes through tailored technology solutions. We specialize in providing comprehensive IT infrastructure, networking, cybersecurity, and cloud solutions that enable businesses to achieve operational excellence and competitive advantage.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="core-values">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">The principles that guide everything we do</p>
          
          <div className="values-grid">
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Integrity</h3>
              <p>We conduct business with honesty, transparency, and ethical practices in all our interactions with clients, partners, and stakeholders.</p>
            </div>
            
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Customer-Centric</h3>
              <p>Our clients are at the heart of everything we do. We prioritize their needs and deliver solutions that exceed expectations.</p>
            </div>
            
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation</h3>
              <p>We embrace new technologies and creative solutions to solve complex business challenges and drive digital transformation.</p>
            </div>
            
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <h3>Excellence</h3>
              <p>We maintain the highest standards of quality in our services, ensuring reliable and high-performance solutions for our clients.</p>
            </div>
            
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Reliability</h3>
              <p>We deliver consistent, dependable solutions that our clients can trust for their critical business operations.</p>
            </div>
            
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Agility</h3>
              <p>We adapt quickly to changing business needs and technology trends to provide flexible, scalable solutions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Expertise */}
      <section className="team-expertise">
        <div className="container">
          <h2 className="section-title">Our Team Expertise</h2>
          <p className="section-subtitle">Meet our team of certified professionals and experienced consultants</p>
          
          <div className="expertise-grid">
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <h3>Certified Professionals</h3>
              <p>Our team comprises experienced consultants and certified professionals committed to providing superior service. We invest in continuous training and certifications to stay current with the latest technologies.</p>
            </div>
            
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3>Enterprise Solution Providers</h3>
              <p>As enterprise solution providers, we are grounded in honesty, integrity, and a customer-centric approach. We focus on delivering cost-effective, high-quality solutions tailored to our clients' specific needs.</p>
            </div>
            
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Strategic Partnerships</h3>
              <p>We are proud to be authorized business partners of leading global technology brands, including Acer, HPE, PeopleLink, Molex, D-Link, Techroutes, Aruba, Systrome, Matrix, and Vantageo.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-about">
        <div className="container">
          <h2 className="section-title">Why Choose TecMates?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Comprehensive Security</h3>
              <p>End-to-end cybersecurity solutions including next-gen firewalls, endpoint protection, and identity management.</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <i className="fas fa-cloud"></i>
              </div>
              <h3>Cloud Excellence</h3>
              <p>Expert cloud migration, virtualization, and disaster recovery solutions for modern enterprises.</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <i className="fas fa-network-wired"></i>
              </div>
              <h3>Advanced Networking</h3>
              <p>SD-WAN, enterprise LAN/WAN design, and wireless network solutions for seamless connectivity.</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <i className="fas fa-tools"></i>
              </div>
              <h3>24/7 Support</h3>
              <p>Round-the-clock monitoring, maintenance, and support services to ensure your systems run smoothly.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how TecMates can help accelerate your digital transformation journey and achieve your technology goals.</p>
          <Link to="/contact" className="btn btn-primary">Get Started Today</Link>
        </div>
      </section>
    </div>
  );
};

export default About; 